import previewVito from 'assets/preview_vito.webp'
import previewSprinter from 'assets/preview_sprinter.webp'
import previewEVito from 'assets/preview_evito.webp'
import previewESprinter from 'assets/preview_sprinter.jpg'

export const vehicleImage = (vehicleGroup: string) => {
  const group = vehicleGroup.toLowerCase()
  switch (group) {
    case 'sprinter':
      return previewSprinter
    case 'vito':
      return previewVito
    case 'esprinter':
      return previewESprinter
    case 'evito':
      return previewEVito
    default:
      return previewSprinter
  }
}
